import { Component, OnInit, ViewChild } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { ValidationService } from 'src/app/common/services/validation.service';
import { MatSelect } from '@angular/material/select';
import { constObj } from '../../../Constants/constants';
import { LoginService } from '../../../services/Login.service';
import { SessionService } from '../../../services/Session.service';


@Component({
  selector: 'app-provide-feedback',
  templateUrl: './provide-feedback.component.html'
})
export class ProvideFeedbackComponent implements OnInit {
  @Output() myEvent = new EventEmitter<string>();

  loadpagecontent: boolean = false;
  globalcancel: string;
  generalFeedbacklink: string;
  generalFeedbacktext: string;
  providefeedback: string;
  yourfeedback: string;
  globalsubmit: string;
  typeoffeedback: string;
  provideFeedbacksubtext: string;
  provideFeedbacktitle: string;
  feedbackTypeList: { order: number, value: string }[] = [];
  textareaError: string = "";
  feedbackvalidationError: string;
  feedbackTypeValidationError: string;
  paragraph: string;
  section: string;
  topic: string;
  subTopic: string;

  constructor(
    public commonDataService: CommonDataService,
    private graphQlService: GraphqlService,
    private validationService: ValidationService,
    private loginService: LoginService,
    private session: SessionService
  ) {

  }

  navData = {
    crumbData : [],
  };  

  feedBackForm = new FormGroup({
    feedBackEmail: new FormControl(''),
    feedBackEmailVerify: new FormControl(''),
    feedBackType : new FormControl(''),
    feedBackContent: new FormControl(''),
    emailMismatch: new FormControl('')
  })

  userinfo;
  passwordvalidation = new FormControl('');
  @ViewChild("feedBackTypeSelect", { static: false }) nameField: MatSelect;
  userRole: string = "";
  ngOnInit(): void {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.userRole = data.user.roles;
        this.userinfo = data.user;
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.userRole = this.session.userInfo.user.roles;
      this.userinfo = this.session.userInfo.user;
    }
    this.getProfessionalContent();
    this.getprovideFeedbackDropdownValues();
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.feedBackForm.controls[controlName].hasError(errorName);
  }

  enterKey() {
    this.submittFeedback();
  }

  emailLabel: string;
  emailConfirmationLabel: string;
  getProfessionalContent() {
    this.graphQlService.getGlobalLabels().subscribe(data => {
      if (data != null) {
        this.loadpagecontent = true;        
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.emailLabel = labels.filter(x => x.key == "provideFeedback_enterEmail").map(y => y.value);
        this.emailConfirmationLabel = labels.filter(x => x.key == "provideFeedback_verifyEmail").map(y => y.value);
        this.providefeedback = labels.filter(x => x.key == "provideFeedback_header").map(y => y.value);
        this.provideFeedbacksubtext = labels.filter(x => x.key == "provideFeedback_subtext").map(y => y.value);
        this.typeoffeedback = labels.filter(x => x.key == "provideFeedback_title").map(y => y.value);
        this.yourfeedback = labels.filter(x => x.key == "provideFeedback_body").map(y => y.value);
        this.globalcancel = labels.filter(x => x.key == "global_cancel").map(y => y.value);
        this.globalsubmit = labels.filter(x => x.key == "global_submit").map(y => y.value);    
        this.generalFeedbacktext = labels.filter(x => x.key == "generalFeedback_text").map(y => y.value);
        this.generalFeedbacklink = labels.filter(x => x.key == "generalFeedback_link").map(y => y.value);
      }
      else {
        //TODO : check the negative scenario        
      }
    });
  }
    

  getprovideFeedbackDropdownValues() {
    this.graphQlService.getprovideFeedbackDropdown().subscribe(data => {
      if (data != null) {
        this.loadpagecontent = true;
        let typelist: string[] = data.content.data.listItem;
        typelist.forEach(d => {
          let jsonData = JSON.parse(d);
          this.feedbackTypeList.push({ order: jsonData.key, value: jsonData.value });
        });
      }
    });
  }

  closeOverlay() {
    this.myEvent.emit();
  }

  remainingText: number = 0;
  annotationDescriptionChange(value: string) {
    this.remainingText = 4000 - value.length;
  }

  addGeneralFeedback() {
    this.commonDataService.rightOverlayOption.next("General Feedback");
  }

  checkHome(){
  }

  checkfeedBackType() {
    let isValid = true;
    if (!this.validationService.validateRequiredField(this.feedBackForm.controls.feedBackType.value)) {
      this.feedBackForm.controls.feedBackType.setErrors({ 'isEmpty': true });
      this.feedbackTypeValidationError = this.validationService.getErrorMessage('required', this.typeoffeedback, null);
      this.feedBackForm.controls.feedBackType.markAsTouched();
      isValid = false
    }


    if (isValid) {
      this.feedBackForm.controls.feedBackType.setErrors(null);
      this.feedbackTypeValidationError = '';
    }

    return isValid;
  }
  checkEmailValidations() {
    let isEmailValid = this.checkEmail();
    let isVerifiedEmailValid = isEmailValid ? this.checkVerifiedEmail() : true;
    let isEmailMatchingEmailValid = this.matchEmail();

    return (isEmailValid && isVerifiedEmailValid && isEmailMatchingEmailValid) || (this.userRole != "Basic");
  }

  emailError: string;
  checkEmail(): boolean {
    let emailValid = true;
    let email = this.feedBackForm.controls.feedBackEmail;
    if (!this.validationService.validateRequiredField(email.value)) {
      email.setErrors({ 'required': true });
      this.emailError = this.emailLabel;
      email.markAsTouched();
      emailValid = false;
    }
    else if (!this.validationService.validateEmailformat(email.value) || !this.validationService.validateEmailfullformat(email.value)
      || !this.validationService.validateEmailspecialCharformat(email.value) || !this.validationService.validatemailpostionRegexformat(email.value)) {
      email.setErrors({ 'hasInvalidEmail': true });
      this.emailError = this.validationService.getErrorMessage('valid', "email address", null);
      email.markAsTouched();
      emailValid = false
    }
    if (emailValid) {
      email.setErrors(null);
    }

    return emailValid;
  }

  verifiedEmailError: string;
  emailMismatchError: string;
  checkVerifiedEmail(): boolean {
    let emailValid = true;
    let email = this.feedBackForm.controls.feedBackEmailVerify;
    if (!this.validationService.validateRequiredField(email.value)) {
      email.setErrors({ 'required': true });
      this.verifiedEmailError = this.emailConfirmationLabel;
      email.markAsTouched();
      emailValid = false;
    }

    else if (!this.validationService.validateEmailformat(email.value) || !this.validationService.validateEmailfullformat(email.value)
      || !this.validationService.validateEmailspecialCharformat(email.value) || !this.validationService.validatemailpostionRegexformat(email.value)) {
      email.setErrors({ 'hasInvalidEmail': true });
      this.verifiedEmailError = this.validationService.getErrorMessage('valid', "email address", null);
      email.markAsTouched();
      emailValid = false
    }
    if (emailValid) {
      email.setErrors(null);
    }

    return emailValid;
  }

  matchEmail(): boolean {
    let email = this.feedBackForm.controls.feedBackEmail.value;
    let emailVerify = this.feedBackForm.controls.feedBackEmailVerify.value;

    let isValid = this.validationService.compareString(email, emailVerify);

    if (!isValid) {
      this.feedBackForm.controls.emailMismatch.setErrors({ 'emailMismatch': true });
      this.emailMismatchError = "The email addresses entered do not match";
      this.feedBackForm.controls.feedBackEmail.markAsTouched();
      this.feedBackForm.controls.feedBackEmailVerify.markAsTouched();
    }
    else {
      this.feedBackForm.controls.emailMismatch.setErrors(null);
      this.emailMismatchError = null;
    }
    return isValid;
  }

  checkfeedBackContent() {
    let isfeedBackContentValid = true;
    if (!this.validationService.validateRequiredField(this.feedBackForm.controls.feedBackContent.value) || this.feedBackForm.controls.feedBackContent.value.trim() == "") {
      this.feedBackForm.controls.feedBackContent.setErrors({ 'isEmpty': true });
      this.feedbackvalidationError = this.validationService.getErrorMessage('required', this.yourfeedback, null);
      this.feedBackForm.controls.feedBackContent.markAsTouched();
      isfeedBackContentValid = false
    }


    if (isfeedBackContentValid) {
      this.feedBackForm.controls.feedBackContent.setErrors(null);
      this.feedbackvalidationError = '';
    }

    return isfeedBackContentValid;
  }

  submittFeedback() {
    let checkfeedBackTypeValid = this.checkfeedBackType();
    let checkfeedBackContentValid = this.checkfeedBackContent();
    let checkEmailValid = this.checkEmailValidations();

    if (checkfeedBackTypeValid && checkfeedBackContentValid && checkEmailValid)
    {
      this.commonDataService.showLoader.next(true);
      let popup;

      this.commonDataService.currentParagraph.subscribe(data => {
        this.paragraph = data;
      });

      let breadcrumb = [];
      this.commonDataService.breadcrumbPath.subscribe(path => {
        breadcrumb = path.split('~');
        this.section = breadcrumb.pop().match(/(\d+)/)[0];
        this.subTopic = breadcrumb.pop().match(/(\d+)/)[0];
        this.topic = breadcrumb.pop().match(/(\d+)/)[0];
      });

      const body = {
        UserEmail: this.userRole == 'Basic' ? this.feedBackForm.controls.feedBackEmail.value : this.userinfo.email,
        FeedbackType: this.feedBackForm.controls.feedBackType.value,
        FeedbackText: this.feedBackForm.controls.feedBackContent.value,
        Paragraph: this.paragraph,
        Section: this.section,
        Topic: this.topic,
        SubTopic: this.subTopic
      };
      this.graphQlService.SaveToDynamics(body).subscribe(data => {
        this.commonDataService.showLoader.next(false);

        if (data !== null) {
          if (data.success) {
            popup = {
              type: 'success',
              displayTime: 5000,
              position: 'bottom',
              message: constObj.generalFeedbackSuccess
            }
          }
          else {
            popup = {
              type: 'fail',
              displayTime: 5000,
              position: 'bottom',
              message: constObj.generalFeedbacemailFail
            }
          }
        }
        else {
          popup = {
            type: 'fail',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.generalFeedbacemailFail
          }
        }
        this.commonDataService.notificationObject.next(popup);
        this.closeOverlay();
      }, err => {
        console.log(err);
        this.commonDataService.showLoader.next(false);
      });
    }
  }

}
